module.exports = __webpack_public_path__ + "static/img/syhbs.f85640b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/syhbs.png
// module id = /w+c
// module chunks = 0